import React from 'react';

const FileOperationOutput = ({ output }) => {
  if (!output) return null;

  // Pretty-print JSON if it's an object
  const formattedOutput =
    typeof output === 'object' ? JSON.stringify(output, null, 2) : output;

  return (
    <div>
      <pre className="overflow-x-auto rounded-md bg-zinc-900 p-2 font-mono text-sm text-gray-100 shadow-md">
        {formattedOutput}
      </pre>
    </div>
  );
};

export default FileOperationOutput;
